export const PRICING_OPTIONS = [
  {
    slug: 'free',
    name: 'Free',
    price: '$0',
    audience: 'Run the full product before paying',
    summary:
      'Everything is available on Free. The limit is capacity, not access, so teams can connect real systems, run real reviews, and feel the workflow before upgrading.',
    priceDetail: 'Included credits',
    onboarding: null,
    included: [
      '1 workspace',
      'Connect GitHub, AWS, Google Workspace, and Google Cloud',
      '12 system sync credits',
      '5 website trust review credits',
      '25 AI guidance credits',
      'Controls, risks, policies, tasks, responses, access reviews, and audit packet workflows'
    ],
    excluded: [
      'No extra credits after the included pool runs out'
    ],
    ctaLabel: 'Keep using Free',
    selectable: true
  },
  {
    slug: 'pro',
    name: 'Pro',
    price: '$100',
    audience: 'For teams running Liance every week',
    onboarding: null,
    priceDetail: 'per month',
    summary:
      'Same product, much higher capacity. Pro is for teams that want Liance in the loop continuously instead of proving it once and stopping there.',
    included: [
      'Everything in Free',
      '200 system sync credits',
      '25 website trust review credits',
      '250 AI guidance credits',
      'More room for recurring evidence, response drafting, and operator work'
    ],
    excluded: [],
    bestUse:
      'Pro is for the team that already felt the value and now wants enough credit headroom to keep Liance active across multiple systems every month.',
    ctaLabel: 'Choose Pro',
    selectable: true,
    featured: true
  }
];

export const SELF_SERVE_PLAN_SLUGS = new Set(['pro']);

export const LANDING_PLAN_DIALOG_REASONS = {
  free: 'Start in the app and compare plans inside the live workspace billing flow.',
  pro: 'Pro was selected from the landing page. Continue in-app when you are ready to buy.'
};

export function normalizePricingPlanSlug(value) {
  const normalized = typeof value === 'string' ? value.trim().toLowerCase() : '';
  const aliases = {
    'trust-monitor': 'pro',
    'operator-starter': 'pro'
  };
  const resolved = aliases[normalized] || normalized;
  return PRICING_OPTIONS.some((plan) => plan.slug === resolved) ? resolved : '';
}

export function buildAppPricingPath(planSlug = '') {
  const normalizedPlanSlug = normalizePricingPlanSlug(planSlug);
  return normalizedPlanSlug ? `/pricing?plan=${encodeURIComponent(normalizedPlanSlug)}` : '/pricing';
}
